var XPortal = XPortal || {};
XPortal.CustomEvents = (function () {
    const helpers = {
        async PPH01_UpdateHelpDeskTicketDate(context, action, next) {
            if (!context || !action) return warn('event to [update help desk ticket dates] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "RegisteredStatus", "Urgency") || !context.isForEntity("HelpDeskTicket")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrStatus = getObjValueLCase(before, "RegisteredStatus");
            const dBfrUrgncy = getObjValueLCase(before, "Urgency");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftStatus = getObjValueLCase(curModel.entity, "RegisteredStatus");
            const dAftUrgncy = getObjValueLCase(curModel.entity, "Urgency");
            if (!dAftStatus || !dAftUrgncy || (dAftStatus == dBfrStatus && dAftUrgncy == dBfrUrgncy)) return;


            if (dAftStatus == 'registered') {
                warn('start: pph01 updating duedate by rules:' + action.field.field + '', -1, { dAftStatus, dAftUrgncy });
                XPortal.Store.GetRelatedData({
                    url: "/umbraco/surface/HDesk/CalcDueDate", request: {
                        uniqueid: getObjValueLCase(curModel.entity, "uniqueid"), parentInfo: getParentInfo(action.model), entityAlias: curModel.model.Alias.toLowerCase(), nodeId: curModel.model.NodeId,
                        status: dAftStatus
                    }
                }).then(function (response) {
                    if (!response || response.State < 0) return;
                    const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                    dispatchIfDiff(action.model, curEntity, response, "duedate", "duedatestr");
                });
            }
        },
        async PPH02_UpdateHelpDeskTicketStatusByEstimation(context, action, next) {
            if (!context || !action) return warn('event to [update help desk ticket status] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "Status") || !context.isForEntity("EstimatesApprovalFlow")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrStatus = getObjValueLCase(before, "Status");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftStatus = getObjValueLCase(curModel.entity, "Status");
            if (!dAftStatus || (dAftStatus == dBfrStatus)) return;


            warn('start: pph01 updating hdtstatus by rules:' + action.field.field + '', -1, { dAftStatus, curDate, curDateTime });
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/HDesk/HDTStatusByEstimation", request: {
                    uniqueid: getObjValueLCase(curModel.entity, "uniqueid"), parentInfo: getParentInfo(action.model), entityAlias: curModel.model.Alias.toLowerCase(), nodeId: curModel.model.NodeId,
                    status: dAftStatus
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                const prtMName = XPortal.Store.GetParentModelName(action.model);
                if (prtMName && prtMName.length > 0) {
                    const prtModelEntity = XPortal.Store.GetModelByName(prtMName).entity;
                    if (getObjValue(response, "HDTItemStatus"))
                        dispatchIfDiff(prtMName, prtModelEntity, response, "Status", "HDTItemStatus");
                    if (getObjValue(response, "AssignedTo"))
                        dispatchIfDiff(prtMName, prtModelEntity, response, "AssignedTo", "AssignedTo");
                }
            });
        },
        async PPH03_UpdateHelpDeskTicketProjectTitle(context, action, next) {
            if (!context || !action) return warn('event to [update help desk ticket ProjectTitle ] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "portalprojectno") || !context.isForEntity("HelpDeskTicket")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrPrjNo = getObjValueLCase(before, "portalprojectno");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftPrjNo = getObjValueLCase(curModel.entity, "portalprojectno");
            if (!dAftPrjNo || (dAftPrjNo == dBfrPrjNo)) return;

            if (dBfrPrjNo == dAftPrjNo) return;
            if (!dAftPrjNo) return;

            const xquery = context.getQuery("no", "=", dAftPrjNo);
            context.RelatedData.Project(xquery).then(function (response) {
                const lookUpEntity = response.filter(itm => itm.no.toLowerCase() === dAftPrjNo);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, dAftPrjNo, lookUpEntity);
                if (lookUpEntity.length < 1) return warn('there are no such project', 0, dAftPrjNo, lookUpEntity);

                const project = lookUpEntity[0];
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                dispatchIfDiff(action.model, curEntity, project, "ProjectTitle", "title");

            }, function (h, e, o) { });
        },
        async SH_UpdateHelpdeskTicketCustomerName(context, action, next) {
            if (!context || !action) return warn('event to [update help desk ticket CustomerName ] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "customerno") || !context.isForEntity("HelpDeskTicket")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrCustNo = getObjValueLCase(before, "customerno");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftCustNo = getObjValueLCase(curModel.entity, "customerno");
            if (!dAftCustNo || (dAftCustNo == dBfrCustNo)) return;

            if (dBfrCustNo == dAftCustNo) return;
            if (!dAftCustNo) return;

            const xquery = context.getQuery("no", "=", dAftCustNo);
            context.RelatedData.Customer(xquery).then(function (response) {
                const lookUpEntity = response.filter(itm => itm.no?.toLowerCase() === dAftCustNo);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, dAftCustNo, lookUpEntity);
                if (lookUpEntity.length < 1) return warn('there are no such customer', 0, dAftCustNo, lookUpEntity);

                const customer = lookUpEntity[0];
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                dispatchIfDiff(action.model, curEntity, customer, "CustomerName", "name");

            }, function (h, e, o) { });
        },
        async UpdateHelpdeskTicketStatusDates(context, action, next) {
            if (!context || !action) return warn('event to [update help desk ticket dates by status ] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "Status") || !context.isForEntity("HelpDeskTicket")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrStatus = getObjValueLCase(before, "Status");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftStatus = getObjValueLCase(curModel.entity, "Status");
            if (!dAftStatus || (dAftStatus == dBfrStatus)) return;

            if (dBfrStatus == dAftStatus) return;
            if (!dAftStatus) return;
            const curDate = new Date().toLocaleString();
            warn('start: Update Helpdesk Ticket Status Dates:' + action.field.field + '', -1, { dAftStatus, curDate });
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/HDesk/HDTDatesByStatus", request: {
                    uniqueid: getObjValueLCase(curModel.entity, "uniqueid"), parentInfo: getParentInfo(action.model), entityAlias: curModel.model.Alias.toLowerCase(), nodeId: curModel.model.NodeId,
                    status: dAftStatus,
                    curDate: curDate
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                UpdateDatesByStatus(curEntity, action, response);
                UpdateMemberInfo(curEntity, action, response);
            });
        },

        async SupportContract_GetСustomerInfoByNo(context, action, next) {
            if (!context || !action || !context.RelatedData.Customer || !context.RelatedData.Contact) return warn('event to [update customer infor by no] has been called incorrectly!!!', 1);
            if ((!context.isOneOfFields(action, "BillToCustomerNo") && !context.isOneOfFields(action, "ContactNo")) || !context.isForEntity("Project")) return;//BillToCustomerName

            if (context.isOneOfFields(action, "BillToCustomerNo")) {
                const before = XPortal.Store.GetModelByName(action.model).entity;
                const dBfrCNo = getObjValueLCase(before, "BillToCustomerNo");
                next(action);
                action.preventDefault = true;
                const curModel = XPortal.Store.GetModelByName(action.model);
                const dAftCNo = getObjValueLCase(curModel.entity, "BillToCustomerNo");
                if (dBfrCNo == dAftCNo) return;


                var setCustomerValues = (customer) => {
                    const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                    dispatchIfDiff(action.model, curEntity, customer, "BilltoName", "name");
                };
                var setContactValues = (contact) => {
                    const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                    dispatchIfDiff(action.model, curEntity, contact, "ContactNo", "no");
                };
                if (!dAftCNo) {
                    setCustomerValues({});
                    setContactValues({});
                    return;
                }
                const xquery = context.getQuery("no", "=", dAftCNo);
                context.RelatedData.Customer(xquery).then(function (response) {
                    const dAftCNoLC = dAftCNo.toLowerCase();
                    const lookUpEntity = response.filter(itm => itm.no.toLowerCase() === dAftCNoLC);
                    if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, lookUpEntity);
                    if (lookUpEntity.length < 1) return warn('there are no such customer', 0, lookUpEntity);
                    setCustomerValues(lookUpEntity[0])
                }, function (h, e, o) { });
                context.RelatedData.Contact(context.getQuery("customerno", "=", dAftCNo), null, null, "customerno").then(function (response) {
                    const dAftCNoLC = dAftCNo.toLowerCase();
                    const lookUpEntity = response.filter(itm => itm.customerno.toLowerCase() === dAftCNoLC);
                    if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, lookUpEntity);
                    if (lookUpEntity.length < 1) {
                        setContactValues({});
                        return warn('there are no such contact', 0, lookUpEntity);
                    }
                    setContactValues(lookUpEntity[0]);
                }, function (h, e, o) { });
            }

            if (context.isOneOfFields(action, "ContactNo")) {
                const before = XPortal.Store.GetModelByName(action.model).entity;
                const dBfrNo = getObjValueLCase(before, "ContactNo");
                next(action);
                action.preventDefault = true;
                const curModel = XPortal.Store.GetModelByName(action.model);
                const dAftNo = getObjValueLCase(curModel.entity, "ContactNo");
                if (dBfrNo == dAftNo) return;

                var setContactValuesByNo = (contact) => {
                    const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                    dispatchIfDiff(action.model, curEntity, contact, "ContactNo", "no");
                    dispatchIfDiff(action.model, curEntity, contact, "ContactName", "name");
                    dispatchIfDiff(action.model, curEntity, contact, "ContactEmail", "email");
                };
                if (!dAftNo) {
                    setContactValuesByNo({});
                    return;
                }
                const xquery = context.getQuery("no", "=", dAftNo);
                context.RelatedData.Contact(xquery).then(function (response) {
                    const dAftCNameLC = dAftNo.toLowerCase();
                    const lookUpEntity = response.filter(itm => itm.no.toLowerCase() === dAftCNameLC);
                    if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, lookUpEntity);
                    if (lookUpEntity.length < 1) return warn('there are no such contact', 0, lookUpEntity);
                    setContactValuesByNo(lookUpEntity[0]);
                }, function (h, e, o) { });
            }

        },
        async HDT_TotalTimesCalculation(context, action, next) {
            if (!context || !action) return warn('event to [update total times] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "time", "status", "*") || !context.isForEntity("EstimatesApprovalFlow") || !action.field || !action.field.field) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrTime = getObjValueLCase(before, "time");
            const dBfrSt = getObjValueLCase(before, "status");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftTime = getObjValueLCase(curModel.entity, "time");
            const dAftSt = getObjValueLCase(curModel.entity, "status");

            if (dBfrTime == dAftTime && dBfrSt == dAftSt && !context.isOneOfFields(action, "*")) return;

            const prtMName = XPortal.Store.GetParentModelName(action.model);
            updateHelpDeskTicketByEstimateChanges(prtMName, action.model);
        },
        async LinkedTickets_Validation(context, action, next) {
            if (!context || !action) return warn('event to [LinkedTickets_Validation] has been called incorrectly!!!', 1);
            const processingFields = ["linktype", "parentticketno", "ticketno"];
            if (!context.isOneOfFields(action, ...processingFields) || !context.isForEntity("LinkedTickets")) return;

            const beforeModel = XPortal.Store.GetModelByName(action.model);
            const selector = beforeModel.model.selector;
            const before = beforeModel.entity;
            const dBfrLType = getObjValueLCase(before, "linktype");
            const dBfrPTNo = getObjValueLCase(before, "parentticketno");
            const dBfrTNo = getObjValueLCase(before, "ticketno");
            let processingFieldDisplayTextPrev = XPortal.Template.GetObjPropValueByName(before, action.field.field);
            let processingFieldPrev = XPortal.Template.GetObjPropValueByName(before, action.field.field);

            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const curEntity = curModel.entity;
            const dAftLType = getObjValueLCase(curEntity, "linktype");
            const dAftPTNo = getObjValueLCase(curEntity, "parentticketno");
            const dAftTNo = getObjValueLCase(curEntity, "ticketno");

            if (dBfrLType == dAftLType && dBfrPTNo == dAftPTNo && dBfrTNo == dAftTNo) return;
            const funcData = {
                dBfrLType, dBfrPTNo, dBfrTNo, dAftLType, dAftPTNo, dAftTNo,
                currentEntityUniqueId: curEntity.UniqueId
            };

            const xquery = context.getQuery("parentticketno", "=", dAftPTNo, null, "or");
            const xxquery = context.getQuery("ticketno", "=", dAftPTNo, xquery, "or");
            await context.RelatedData.LinkedTickets(xxquery, null, null, "ticketno").then(function (res) {
                var lnItem = !res || !res.length ? null : res;
                var allowToChange = !lnItem || linkTickets_IsTicketCombinationCheckOk(lnItem, funcData) && linkTickets_IsParentCheckOk(lnItem, funcData) && linkTickets_IsNotDuplicate(lnItem, funcData);
                if (!allowToChange) {
                    const fname = action.field.field;
                    //XPortal.Store.DispatchByName(action.model, fname, processingFieldPrev, false, true);
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_CANCEL, modelName: action.model });
                    var ginfo = XPortal.Grid.GetGridInfo(selector);
                    if (ginfo && ginfo.kgrid) {
                        ginfo.kgrid.dataSource.read();
                        ginfo.kgrid.refresh();
                    }
                }
            });
        },
        async UpdateProjectPersonResponsibleEmail(context, action, next) {
            if (!context || !action) return warn('event to [update Project PersonResponsibleEmail ] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "personresponsible") || !context.isForEntity("Project")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrPrjNo = getObjValueLCase(before, "personresponsible");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftPrjNo = getObjValueLCase(curModel.entity, "personresponsible");
            if (dAftPrjNo == dBfrPrjNo) return;
            const curEntity = XPortal.Store.GetModelByName(action.model).entity;
            if (!dAftPrjNo) {
                dispatchIfDiff(action.model, curEntity, { email: "" }, "personresponsibleemail", "email");
                return;
            }

            const xquery = context.getQuery("name", "=", dAftPrjNo);
            context.RelatedData.Resource(xquery).then(function (response) {
                const lookUpEntity = response.filter(itm => itm.name.toLowerCase() === dAftPrjNo);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, dAftPrjNo, lookUpEntity);
                if (lookUpEntity.length < 1) {
                    dispatchIfDiff(action.model, curEntity, { email: "" }, "personresponsibleemail", "email");
                    return warn('there are no such project', 0, dAftPrjNo, lookUpEntity);
                }

                const resource = lookUpEntity[0];
                dispatchIfDiff(action.model, curEntity, resource, "personresponsibleemail", "email");
            }, function (h, e, o) { });
        },
        async UpdateHelpDeskTicketProjectResponsibleSupportPerson(context, action, next) {
            if (!context || !action) return warn('event to [update HelpDeskTicket ProjectResponsibleSupportPerson] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "portalprojectno") || !context.isForEntity("HelpDeskTicket")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrPrjNo = getObjValueLCase(before, "portalprojectno");
            next(action);
            action.preventDefault = true;
            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftPrjNo = getObjValueLCase(curModel.entity, "portalprojectno");
            if (dAftPrjNo == dBfrPrjNo) return;
            const curEntity = XPortal.Store.GetModelByName(action.model).entity;
            if (!dAftPrjNo) {
                dispatchIfDiff(action.model, curEntity, { supportresponsibleperson: "" }, "projectresponsiblesupportperson", "supportresponsibleperson");
                return;
            }

            const xquery = context.getQuery("no", "=", dAftPrjNo);
            context.RelatedData.Project(xquery).then(function (response) {
                const lookUpEntity = response.filter(itm => itm.no.toLowerCase() === dAftPrjNo);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, dAftPrjNo, lookUpEntity);
                if (lookUpEntity.length < 1) {
                    dispatchIfDiff(action.model, curEntity, { supportresponsibleperson: "" }, "projectresponsiblesupportperson", "supportresponsibleperson");
                    return warn('there are no such project', 0, dAftPrjNo, lookUpEntity);
                }

                const project = lookUpEntity[0];
                dispatchIfDiff(action.model, curEntity, project, "projectresponsiblesupportperson", "supportresponsibleperson");
            }, function (h, e, o) { });
        },
        async HDT_UpdateResponseAndResolutionPercent(context, action, next) {
            if (!context || !action) return warn('[HDT_UpdateResponseAndResolutionPercent] called incorrectly', 1);
            if (!context.isForEntity('HelpDeskTicket')) return;

            const slaResponseChanged = 'SLAResponseTime';
            const slaResolutionChanged = 'SLAResolutionTime';

            if (action.type !== 'LOADED_ENTITY' && !context.isOneOfFields(action, slaResponseChanged) && !context.isOneOfFields(action, slaResolutionChanged)) return;

            const workStart = '09:00';
            const workEnd = '17:00';
            const holidays = ['01.01', '04.12', '04.13', '06.28', '06.29', '07.15', '08.24', '12.25'];

            next(action);
            action.preventDefault = true;

            const entity = XPortal.Store.GetModelByName(action.model).entity;
            calcAndDispatchSLAPercent(action.model, entity, 'ResponseClockStart', 'ResponseClockStop', 'ResponseClockTotal', slaResponseChanged, 'ResponseTimePercent', workStart, workEnd, holidays);
            calcAndDispatchSLAPercent(action.model, entity, 'SLAClockStart', 'SLAClockStop', 'SLAClockTotal', slaResolutionChanged, 'ResolutionTimePercent', workStart, workEnd, holidays);
        },
    };

    function calcAndDispatchSLAPercent(modelName, entity, startField, stopField, totalField, targetField, outputField, workStart, workEnd, holidays) {
        const hours = parseFloat(XPortal.Format.SLAClock({ item: entity }, startField, stopField, totalField, workStart, workEnd, holidays, true));
        const target = parseFloat(getObjValue(entity, targetField));
        const percent = !isNaN(hours) && target > 0 ? Math.round((hours / target) * 100) : '';
        dispatchIfDiff(modelName, entity, { [outputField]: percent }, outputField, outputField);
    };

    function linkTickets_IsParentCheckOk(lnItem, funcData) {
        if (!['parent'].includes(funcData.dAftLType.toLowerCase())) return true;
        if (!funcData.dAftPTNo || !funcData.dAftPTNo.length || !funcData.dAftLType || !funcData.dAftLType.length) return true;

        var resultParentItems = lnItem.filter(f => (f.parentticketno.toLowerCase() == funcData.dAftPTNo.toLowerCase() && f.linktype.toLowerCase() == "parent") && f.UniqueId != funcData.currentEntityUniqueId);

        if (resultParentItems && resultParentItems.length) {
            warn('A ticket can only be linked to one Parent');
            XPortal.EditForm.ShowErrorMessage(null, "Warning", "A ticket can only be linked to one Parent.");
            return false;
        }
        return true;
    };
    function linkTickets_IsNotDuplicate(lnItem, funcData) {
        if (!funcData.dAftPTNo || !funcData.dAftPTNo.length || !funcData.dAftLType || !funcData.dAftLType.length || !funcData.dAftTNo || !funcData.dAftTNo.length) return true;

        var resultDuplicateItems = lnItem.filter(f => (f.parentticketno.toLowerCase() == funcData.dAftPTNo && f.linktype.toLowerCase() == funcData.dAftLType && f.ticketno.toLowerCase() == funcData.dAftTNo && f.UniqueId != funcData.currentEntityUniqueId));
        if (resultDuplicateItems && resultDuplicateItems.length) {
            warn('This ticket is already linked to the selected ticket with the same relationship type.');
            XPortal.EditForm.ShowErrorMessage(null, "Warning", "This ticket is already linked to the selected ticket with the same relationship type.");
            return false;
        }
        return true;
    };
    function linkTickets_IsTicketCombinationCheckOk(lnItem, funcData) {
        if (!funcData.dAftPTNo || !funcData.dAftPTNo.length || !funcData.dAftTNo || !funcData.dAftTNo.length || !funcData.dAftLType || !funcData.dAftLType.length) return true;
        var resultParentItems = {};

        if (funcData.dAftLType == "child") {
            resultParentItems = lnItem.filter(f => ((((f.parentticketno.toLowerCase() == funcData.dAftPTNo && f.ticketno.toLowerCase() == funcData.dAftTNo && (f.linktype.toLowerCase() == "parent" || f.linktype.toLowerCase() == "related")))
                || (f.ticketno.toLowerCase() == funcData.dAftPTNo && f.parentticketno.toLowerCase() == funcData.dAftTNo) && (f.linktype.toLowerCase() == "child" || f.linktype.toLowerCase() == "related"))) && f.UniqueId != funcData.currentEntityUniqueId);
        } else if (funcData.dAftLType == "parent") { // linktype = Parent
            resultParentItems = lnItem.filter(f => ((((f.parentticketno.toLowerCase() == funcData.dAftPTNo && f.ticketno.toLowerCase() == funcData.dAftTNo && (f.linktype.toLowerCase() == "child" || f.linktype.toLowerCase() == "related")))
                || (f.ticketno.toLowerCase() == funcData.dAftPTNo && f.parentticketno.toLowerCase() == funcData.dAftTNo) && (f.linktype.toLowerCase() == "parent" || f.linktype.toLowerCase() == "related"))) && f.UniqueId != funcData.currentEntityUniqueId);
        } else { // linktype = Related
            resultParentItems = lnItem.filter(f => ((((f.parentticketno.toLowerCase() == funcData.dAftPTNo && f.ticketno.toLowerCase() == funcData.dAftTNo && (f.linktype.toLowerCase() == "child" || f.linktype.toLowerCase() == "parent")))
                || (f.ticketno.toLowerCase() == funcData.dAftPTNo && f.parentticketno.toLowerCase() == funcData.dAftTNo) && (f.linktype.toLowerCase() == "child" || f.linktype.toLowerCase() == "parent"))) && f.UniqueId != funcData.currentEntityUniqueId);
        }

        if (resultParentItems && resultParentItems.length) {
            warn('A ticket cannot be both Parent and Child, or Parent and Related, or Child and Related at the same time.');
            XPortal.EditForm.ShowErrorMessage(null, "Warning", "A ticket cannot be both Parent and Child, or Parent and Related, or Child and Related at the same time.");
            return false;
        }
        return true;
    };
    function updateHelpDeskTicketByEstimateChanges(prtMName, crtMName) {
        const prtMContainer = XPortal.Store.GetModelByName(prtMName);
        window.clearTimeout(prtMContainer.ttlTimeout);
        prtMContainer.ttlTimeout = window.setTimeout(function () {
            const crtModel = XPortal.Store.GetModelByName(crtMName);
            const grdLines = crtModel.GetGridItems() || [];
            if (!grdLines.length)
                return;
            let timeAll = 0;
            let approvedTime = 0;
            let toApproveTime = 0;
            let rejectedTime = 0;
            let originalEstimate = 0;
            grdLines.forEach(l => {
                if (l.hasOwnProperty('*')) return;
                const xtime = Number(getObjValue(l, "time"));
                const time = (isNaN(xtime) || xtime < 0 ? 0 : xtime);
                const statusLC = getObjValue(l, "status").toLowerCase();

                timeAll = timeAll + time;
                if (statusLC == "approved") approvedTime = approvedTime + time;
                if (statusLC == "rejected") rejectedTime = rejectedTime + time;
                if (statusLC == "to approve") toApproveTime = toApproveTime + time;

                const estimateType = getObjValue(l, "typeofestimates").toLowerCase();
                if (estimateType.toLowerCase() == "original estimate") originalEstimate += time;
            });

            const resE = { totaltoapprove: String(toApproveTime), totalrequested: String(timeAll), totalapproved: String(approvedTime), totalrejected: String(rejectedTime), originalestimates: String(originalEstimate) };
            dispatchIfDiff(prtMName, prtMContainer.entity, resE, "totaltoapprove", "totaltoapprove");
            dispatchIfDiff(prtMName, prtMContainer.entity, resE, "totalapproved", "totalapproved");
            dispatchIfDiff(prtMName, prtMContainer.entity, resE, "totalrejected", "totalrejected");
            dispatchIfDiff(prtMName, prtMContainer.entity, resE, "totalrequested", "totalrequested");
            dispatchIfDiff(prtMName, prtMContainer.entity, resE, "originalestimates", "originalestimates");


        }, 500);
    };
    function subscribeForAnyStoreChanges() {
        waitFor(function () {
            if (XPortal["Store"] && XPortal["Store"]["AppStore"]) {
                const store = XPortal.Store.AppStore;
                helpers.unsubscribe = helpers.unsubscribe || store.subscribe(() => {
                    var laction = store.getState().lastAction;
                    ensureHDTModified(laction);
                });
                return true;
            } else return false;
        }, waitFor);
    };
    function ensureHDTModified(action) {
        if (!action || action.type != "Complex.ModifyRecord.Successful") return;
        const modelName = action.modelName || action.model;
        const actionModel = XPortal.Store.GetModelByName(modelName);
        const curEntityName = actionModel.model.Alias.toLowerCase();
        if (!(curEntityName == "estimatesapprovalflow" || curEntityName == "helpdeskticket")) return;
        const sttgs = action.popupOpts || action.options;
        const prtMName = XPortal.Store.GetParentModelName(modelName);
        if (prtMName && prtMName.length > 0) {
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const prtModelEntity = prtModel.entity;
            if (!XPortal.Store.IsAnyFieldsEditable(prtMName, "status", "assignedto")) return;

            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/HDesk/HDTStatus", request: {
                    uniqueid: getObjValueLCase(prtModelEntity, "uniqueid"), parentInfo: null, entityAlias: prtModel.model.Alias.toLowerCase(), nodeId: prtModel.model.NodeId
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                if (getObjValue(response, "HDTItemStatus"))
                    dispatchIfDiff(prtMName, prtModelEntity, response, "Status", "HDTItemStatus");
                if (getObjValue(response, "AssignedTo"))
                    dispatchIfDiff(prtMName, prtModelEntity, response, "AssignedTo", "AssignedTo");
            });
        }
    };


    function dispatchIfDiff(modelName, curData, srcData, cFname, sFname) {
        var cval = getObjValue(curData, cFname);
        var sval = getObjValue(srcData, sFname);
        if (cval != sval) {
            XPortal.Store.DispatchByName(modelName, cFname, sval, false, true);
        }
    };
    function dispatchIfEmpty(modelName, curData, srcData, cFname, sFname) {
        var cval = getObjValue(curData, cFname);
        var sval = getObjValue(srcData, sFname);
        if (!cval || cval != "")
            XPortal.Store.DispatchByName(modelName, cFname, sval);
    };

    function getParentInfo(modelName) {
        const pmodelName = XPortal.Store.GetParentModelName(modelName);
        const pmodel = pmodelName ? XPortal.Store.GetModelByName(pmodelName) : null;
        if (!pmodel) return null;
        const parentUid = (XPortal.Template.GetObjPropValueByName(pmodel.entity || {}, "uniqueid") || "");
        if (!parentUid || !pmodel.model) return null;
        return pmodel.model.NodeId + "#|#" + parentUid;
    };
    function getObjValue(o, prname, dval) {
        const r = XPortal.Template.GetObjPropValueByName(o, prname);
        if (dval && !r) return dval;
        return r;
    };
    function getObjValueLCase(o, prname) {
        const v = XPortal.Template.GetObjPropValueByName(o, prname);
        return tLowerCase(v);
    };
    function tLowerCase(o, dv) {
        const so = o ? String(o).toLowerCase() : (dv || "").toLowerCase();
        return so;
    };
    function warn(msg, iscritical, ...args) {
        if (!console) return;
        const stack = [];// (new Error().stack || "").split("\n").slice(1).filter((x) => x.indexOf("portal.store.js") == -1 && x.indexOf("Object.event") == -1 && x.indexOf("Object.EnsureMid") == -1 && x.indexOf("warn (http") == -1);
        if (iscritical > 0) return console.error(msg, [...args, ...stack]);
        if (iscritical == 0) return console.warn(msg, [...args, ...stack]);
        return console.log(msg, [...args, ...stack]);
    };

    function UpdateDatesByStatus(curEntity, action, response) {
        if (curEntity && curEntity.status == "Active")
            dispatchIfDiff(action.model, curEntity, response, "ResponseDate", "ResponseDate");
        else if (curEntity && curEntity.status == "Closed")
            dispatchIfDiff(action.model, curEntity, response, "DateClosed", "ClosedDate");
        else if (curEntity && curEntity.status == "Resolved")
            dispatchIfDiff(action.model, curEntity, response, "ResolvedDate", "ResolvedDate");
        else if (curEntity && curEntity.status == "Approved")
            dispatchIfDiff(action.model, curEntity, response, "ApprovedOn", "ApprovedOn");
        else if (curEntity && curEntity.status == "Rejected")
            dispatchIfDiff(action.model, curEntity, response, "RejectedOn", "RejectedOn");
    };
    function UpdateMemberInfo(curEntity, action, response) {
        if (curEntity && curEntity.status == "Approved")
            dispatchIfDiff(action.model, curEntity, response, "ApprovedBy", "ApprovedBy");
        else if (curEntity && curEntity.status == "Rejected")
            dispatchIfDiff(action.model, curEntity, response, "RejectedBy", "RejectedBy");
    };

    //register events in repository
    function waitFor(onAction, onFalse) { if (!onAction()) { setTimeout(function () { onFalse(onAction, onFalse); }, 100); } };

    waitFor(function () {
        if (XPortal["Events"] && XPortal["Events"]["helpers"]) {
            for (var i in helpers) XPortal.Events.helpers[i] = helpers[i];
            subscribeForAnyStoreChanges();
            return true;
        } else return false;
    }, waitFor);
    //end of registration
    return helpers;
})();

